export default __webpack_public_path__ + "assets/models/8eddec1a7334cca14ed33340858a3c8a.glb";